import React from "react";
import HTMLicon from "../assets/icons/htmlicon.png";
import CSSicon from "../assets/icons/cssicon.png";
import JSicon from "../assets/icons/jsicon.png";
import TSicon from "../assets/icons/tsicon.png";
import instagrambg from "../assets/backgrounds/instagram640.jpg";
import boldeasybg from "../assets/backgrounds/boldeasyreader.jpg";
import swapi from "../assets/backgrounds/swapi.jpeg";
import reactIcon from "../assets/icons/reacticon.png";
import luckyCard from "../assets/backgrounds/luckycard.jpeg";
import hangingman from "../assets/backgrounds/hangingman-min.jpeg";
import githb from "../assets/backgrounds/githubbg.jpg";
import "../styles/portfolio.css";

export const Portfolio = () => {
  const portfolio = [
    {
      id: 1,
      href: "https://github.com/Mjuliafb",
      title: "Complete portfolio",
      background: githb,
      description: "Checkout my repositories at Github.",
      img: [],
    },
    {
      id: 2,
      href: "https://mjuliafb-instagram-photo-feed-with-bootstrap.vercel.app/",
      title: "Instagram photo feed",
      background: instagrambg,
      description: "Instagram feed with photo viewing alternatives.",
      img: [
        {
          id: 1,
          src: HTMLicon,
          alt: "HTML icon",
        },
        {
          id: 2,
          src: CSSicon,
          alt: "CSS icon",
        },
        {
          id: 3,
          src: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/1024px-Bootstrap_logo.svg.png",
          alt: "Bootstrap icon",
        },
      ],
    },
    {
      id: 3,
      href: "https://bold-easy-reader-7m9kycfxz.vercel.app/",
      title: "Bold Easy Reader",
      background: boldeasybg,
      description: "Text converter to improve readability.",
      img: [
        {
          id: 1,
          src: HTMLicon,
          alt: "HTML icon",
        },
        {
          id: 2,
          src: CSSicon,
          alt: "CSS icon",
        },
        {
          id: 3,
          src: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/1024px-Bootstrap_logo.svg.png",
          alt: "Bootstrap icon",
        },
        {
          id: 4,
          src: JSicon,
          alt: "React icon",
        },
      ],
    },
    {
      id: 4,
      href: "https://github.com/Mjuliafb/mjuliafb-vanillajs-hello-card-generator",
      title: "Lucky Card",
      background: luckyCard,
      description: "Find your lucky card.",
      img: [
        {
          id: 1,
          src: HTMLicon,
          alt: "HTML icon",
        },
        {
          id: 2,
          src: CSSicon,
          alt: "CSS icon",
        },
        {
          id: 4,
          src: reactIcon,
          alt: "React icon",
        },
        {
          id: 4,
          src: JSicon,
          alt: "Javascript icon",
        },
      ],
    },
    {
      id: 5,
      href: "https://github.com/Mjuliafb/mjuliafb-react-blog-star-wars",
      title: "Star Wars blog",
      background: swapi,
      description: "SWAPI blog.",
      img: [
        {
          id: 1,
          src: HTMLicon,
          alt: "HTML icon",
        },
        {
          id: 2,
          src: CSSicon,
          alt: "CSS icon",
        },
        {
          id: 3,
          src: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/1024px-Bootstrap_logo.svg.png",
          alt: "Bootstrap icon",
        },
        {
          id: 4,
          src: reactIcon,
          alt: "React icon",
        },
      ],
    },
    {
      id: 6,
      href: "https://unusual-words.netlify.app/",
      title: "Unusual words",
      background: hangingman,
      description: "Hanging man game with unusual words.",
      img: [
        {
          id: 1,
          src: HTMLicon,
          alt: "HTML icon",
        },
        {
          id: 2,
          src: CSSicon,
          alt: "CSS icon",
        },
        {
          id: 3,
          src: reactIcon,
          alt: "React icon",
        },
        {
          id: 4,
          src: TSicon,
          alt: "Typescript icon",
        },
      ],
    },
  ];
  
  const sortedPortfolio = portfolio.sort((a, b) => b.id - a.id);

  return (
    // TODO: hacer css para media query
    <section className="portfolio" id="portfolioSection">
      <div className="cardsPortfolio">
        <div className="container mb-4">
          <h1>Portfolio</h1>
          <div className="row">
            {sortedPortfolio.map((item, index) => (
              <div key={item.id} className="col-sm-4 mt-2">
                <a href={item.href} target="_blank" className="url-box">
                  <figure className="newsCard news-Slide-up ">
                    <img src={item.background} />
                    <div className="newsCaption px-4">
                      <div className="d-flex align-items-center justify-content-between cnt-title">
                        <h5 className="newsCaption-title text-white m-0 text-start">
                          {item.title}
                        </h5>{" "}
                        <i className="fas fa-arrow-alt-circle-right "></i>
                      </div>
                      <div className="newsCaption-content d-flex ">
                        <p className="col-10 py-3 px-0 d-flex text-start">
                          {item.description}
                          {item.img.map((imgItem, imgIndex) => (
                            <img
                              key={imgItem.id}
                              className="portfolioTechs card-img-top"
                              src={imgItem.src}
                              alt={imgItem.alt}
                            />
                          ))}
                        </p>
                      </div>
                    </div>
                    <span className="overlay"></span>
                  </figure>
                </a>
              </div>
            ))}
          </div>
          <p className="details">
            Background images from{" "}
            <a href="https://unsplash.com/es" target="_blank">
              unsplash.com
            </a>{" "}
            and{" "}
            <a href="https://www.bing.com/images/create" target="_blank">
              Image Creator
            </a>{" "}
          </p>
        </div>
      </div>
    </section>
  );
};
